module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter Two")])])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("I")])])])]), _vm._v("f there was one thing Rainy never wanted to be, it was a desperate, husband-hunting woman. So she refused to be happy that the handsome cowboy sitting across from her was unmarried. He was what he was. And so was she.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After she’d hung out her shingle to be a foster mother, with the intention of adopting as many kids as the Lord saw fit, she’d put aside her dreams of a husband. Mostly. If God dropped the right guy into her lap, she wouldn’t argue. She just wasn’t going out looking anymore.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So how long have you attended Bible Fellowship?” Nate was asking.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Since I moved here five years ago. It’s a great church, lots of outreach to the needy, which I think is paramount, plus I love the small-group Bible studies. And the kids’ ministry, of course.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course.” One side of his mouth quirked. “So you’re not from around here, then?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tulsa.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Both eyebrows joined the quirked lips. “City girl.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am not!” She leaned back in her chair, saw he was teasing, and laughed. “Well, not entirely. I like the smaller town life. That’s why I took the job at Robert E. Lee.”")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Summervale isn’t too small anymore.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, but a good mix of small town and big city, don’t you think?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Mostly. Traffic’s gotten snarly since they put in the mall.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nothing like Tulsa at rush hour.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shuddered. “Spare me that. Three cars on a country road are enough for me. What grade you teach?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Second. Five years, and I can’t imagine doing anything else. Kids that age are a hoot—their wiggles, their gap-toothed smiles, their concrete, literal way of looking at the world.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He glanced toward the living room, where the children had adjourned. Mercifully, the house had settled into a quieter rhythm with only a now lower rumble of Cartoon Network and an occasional "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("shh")])]), _vm._v(" or giggle from one of the foursome.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You like kids.” His statement sounded a lot like an accusation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Crazy about them.” Feeling no need to justify what was as natural as breathing, Rainy took another sip of milk. “What do you do, besides rush to the rescue of stressed-out women and their washing machines?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ranch.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Really? A real ranch, like with horses and cows?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("are")])]), _vm._v(" a city girl.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Am not,” she said mildly. “So "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("do")])]), _vm._v(" you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Have horses and cows? Sure. Mostly cattle since that’s how I make my living. Angus beef. But I keep a few horses for fun. I mostly use a Mule for the real work these days.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rainy leaned an elbow on the table, fascinated. She had no idea cowboys rode mules now instead of horses. The idea of lanky Nate on the back of a stubborn mule conjured up a funny mental picture, but she refused to laugh. The guy had gone above and beyond.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Besides, what she knew about ranches and cowboys would fit on a pencil eraser. But a ranch had animals. She knew that ")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("for certain, and animals were good for kids. She’d read any number of articles about their therapeutic value with people who were hurting. Like a tiny seedpod, an idea began to germinate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("She was always on the lookout for opportunities for the children, especially her boys. They needed far more than she could teach them. The only animal she had room or time for was Ralph, the fighting beta fish that only serious Will seemed the least bit interested in. But that was because Will worried about everything and everyone, considering himself the caretaker of the world.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("A ranch meant lots of animals, lots of opportunities, maybe even healing of some of the hurts these children had experienced, and of equal importance, a male role model and a little recreation.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Would you consider letting me bring the kids out to your ranch sometime?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Nate blinked and the air around him stilled. “Why?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("What an odd question. “To see the animals, to see what you do on a ranch. Broaden their horizons. You know, the kind of experiences they won’t get here in this crowded subdivision.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("She loved her home and neighborhood with its family-oriented residents and tidy, colorful flowerbeds and walkways, but most of the yards were small, and houses butted up against each other on either side. A ranch meant room to spread out and run and be noisy.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Nate didn’t appear to be of the same train of thought. Reluctance hung on him like a wet shirt. He studied the rim of his milk glass, gnawed one corner of his lip and didn’t look at her. “A working ranch is no place for kids.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Weak excuse. And she was a teacher. Did he think she’d let him get by with that?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Then, how does one learn to be a rancher?”")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The question seemed to agitate him. He leaned forward, forearms on the table’s edge, hazel eyes clouding toward mud-brown. “I grew up in the country. Farm animals were a part of the natural order of things.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Having taken to heart Christ’s command to care for the needy and orphaned, Rainy was accustomed to pushing when it came to getting things for foster children. After all, she was on a mission for God. If God approved, she didn’t care in the least if people found her pushy. “Are you implying that only those who grow up in the country can be farmers or ranchers?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s not what I meant.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She smiled, feeling victory coming on. One more little push and he’d tumble like stacked dominos. “I’m so glad. I was positive a man thoughtful enough to join the Handyman Ministry would understand how much this could mean to at-risk town kids.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So it was a cheap shot. Rainy had no remorse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nate leaned back in his chair, hands dropping into his lap as he stared at her with exasperation. “You don’t give up, do you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A tiny smile tickled Rainy’s lips. “Never. Not when it comes to my foster kids.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This time, she was the one who leaned forward, pressing, determined as a terrier, her voice dropping low so the children didn’t hear. “You met my kids, Nate, but you have no idea what they’ve lived through. They’re survivors, but they carry scars. Will is too serious and considers the other children his responsibility. Joshua is my encourager, but he shivers and shakes at the first sign of conflict. Emma’s charm can be manipulative. And Katie, poor little Katie—” She choked, tears filling her throat. She had not intended to go this far.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The cowboy across from her raised both hands in surrender. “Okay. They can come.”")])])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rainy pressed back against the hard, wooden chair and drew in a deep, relaxing breath. Thoughts of what these children had suffered and witnessed always tore her apart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sorry. I didn’t mean to get teary on you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No big deal.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But she could see it was. Her handyman was ready to cut and run like a wild horse. Better grab the opportunity while it was knocking. Besides, one trip to the ranch would be a nice start, but she really had something more in mind. “How about tomorrow after church?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He flinched. “So soon?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The weather is supposed to be decent tomorrow. And the kids will go wild with excitement. I promise to keep a tight rein on them. They’re good kids.” When he lifted a doubtful brow, she rushed on, “Really. I promise. Great kids. What do you say?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Before he could answer, Katie’s scream ripped through the air. Rainy pushed back from the table to see what was amiss this time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Great kids, huh?” Nate said without a bit of humor. “You could sell that scream to Hollywood.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rainy chuckled anyway. “I know. Pure, high and bloodcurdling. And most of the time, she’s screaming about nothing.” The scream, however, was Katie’s way to communicate. “Katie has some issues we’re working through, but today the scream might indicate another episode of throwing up. I’ll have to check.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nate got that helpless, eager-to-escape expression again. Well, who could blame the poor guy? No one—not even Rainy—liked dealing with a stomach virus.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As she pushed out of the chair, Will came into the kitchen. “Katie’s all right. She’s mad because I gave one of the babies a stuffed animal.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No throw up?” she asked.")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.” The boy’s serious eyes glanced at the cookies.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Want one?” Nate offered the plate and then thought to ask Rainy, “Is it okay if he has one? He helped me out back there with the hose. Good worker.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Will took the cookie before she could reply, although she would have said yes anyway. “Joshy and Emma got scared. They’re hiding in the closet again.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Because there’s a cop coming up the sidewalk.”")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nate watched as Rainy Jernagen’s face alternately paled and then flushed, a hot-pink color flaring on delicate cheekbones.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are we in trouble?” Will asked, his face alive with worry.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rainy placed a hand on the boy’s narrow shoulder, and in a soft, calm voice asked, “Have we done anything to be in trouble?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, ma’am.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then we have nothing to fear from the police.” She dipped her head low, making eye contact. “They’re our friends, remember?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("From the way the boy’s eyes shifted away, Nate figured he didn’t buy that. Negative experience must have left a scar.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Anything I can do to help?” he heard himself asking, though in reality, he’d had about all of the Jernagen house he wanted for one day. He was baffled as to why he wasn’t escaping out through the garage.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("On second thought, the police wouldn’t look kindly on a male slithering out the back way while they stood on the front porch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rainy lifted blue-gray eyes to his, and he knew why he hadn’t already cut and run.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("A few minutes ago, she’d gotten to him with the mere hint of tears—he was a sucker for a woman’s tears, as his sister ")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("well knew. And Rainy was kind and gentle and patient with the children, even though she was obviously running on adrenaline and little sleep. She was cute, too, now that her hair was brushed and she didn’t look like a troll doll about to explode with stress. If he was truthful, she’d been cute all along, though he’d not wanted to notice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("But he was a man, and admiring a pretty, sweet woman came naturally. He couldn’t change biology.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("If she didn’t have this passel of kids, he might even have asked her out.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("A chill tingled his nerve endings.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("If")])]), _vm._v(" was a big, big word. He and kids didn’t mix, and Rainy’s devotion to the children was obviously more than a do-good activity to make herself feel charitable. She was passionate, with a missionary zeal.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("Nate Del Rio simply did not understand the sentiment. Kids were a pain. Trouble. He knew from ugly, tenacious experience.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("The doorbell played another round of hideous rock music. Rainy jumped.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("She gave Will a reassuring pat on the shoulder and a gentle push. “If you’ll check on Emma and Josh, I’ll talk to the policeman first and then I’ll be right in. Don’t worry. Everything is fine.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("She started into the living room, knees trembling. The nervous reaction made her almost as angry as the notion of someone intentionally frightening her kids. And she had no doubt this was the case.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("Strong fingers caught her by the arm. “Why don’t I answer the door?” Nate said. “So you can take care of the little ones.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("She blinked her surprise, touched by his concern. “Thanks, but we’ve done this before. It will only take a minute.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("He dropped his hold. “The police come here often?”")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“More often than I’d like,” she said grimly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Kathy Underkircher and her hostility were wearing thin, for Rainy was certain that the woman who had decided to hate her for reasons that had nothing to do with these children had once again called the police.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why? You don’t seem the kind to cause trouble.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not.” She waved him off. “It’s too complicated to explain right now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The doorbell screamed again and, under other circumstances, Nate’s flinch would have made Rainy laugh. The awful music had that effect on everyone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What is with the musical doorbell?” he asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My brother installed it. His idea of a joke.” She pushed a stray lock of hair behind one ear and said a little prayer as she gazed around the living room. The place looked better, if not perfect. But who expected perfect with children?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not your kind of music?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What?” she asked. “Oh, the bell. Despise it. Don’t know how to dismantle it.” She reached for the doorknob as the raucous tune restarted. Through gritted teeth, she said, “If that thing wakes the babies, I’ll take a hammer to it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Behind her Nate chuckled. “Sounds like a handyman job to me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It occurred to her then that he was still here. By now the handsome cowboy—the handsome "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("single")])]), _vm._v(" cowboy—would be convinced he’d fallen into some alternative dimension filled with screaming kids, throw up, overflowing washers, irritating music and a policeman on the doorstep. Could her day get any worse? Might as well find out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She ripped the door open with a little more force than needed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A familiar officer in a blue uniform stood in the cool shade of the tulip-bordered porch. Sun glinted off his silver Summervale police badge.")])])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Miss Jernagen?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hello, Officer Wagner,” she said with a sigh. “Kathy Underkircher again?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The policeman’s head dipped slightly. “Anonymous caller. Sorry to disturb you but screaming was reported again. Is there a problem?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The anonymous caller was Kathy, all right. The woman would never forgive her, no matter how she tried to mend the rift.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“None that needs police,” Nate said, stepping up beside Rainy to extend his hand to the officer. “Nate Del Rio. Rainy and I attend the same church. Don’t I know you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Del Rio?” the young officer rubbed his chin. “Yeah, yeah. You got that ranch outside of town. Right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s right. Crossroads Ranch.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My dad bought a heifer off you a while back for my little brother’s agriculture project at school. I came with him to pick her up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nate’s head bobbed. “I remember. Good breeding stock.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rainy looked back and forth between the two men. It was considerate of Nate to be cordial but he had no idea she and Officer Wagner were old hands at this. She didn’t need anyone to soften up the policeman with chitchat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Listen, gentlemen, I have four frightened children in there to attend to. Could we have this little reunion later?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Chagrined, the officer nodded. “Sorry, ma’am. Do you mind if I come in? Check things out?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You know there’s nothing wrong in here,” she said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, ma’am, but I have to check.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know. I know.” She rolled her eyes heavenward, as much to beseech the Lord’s help as for effect. “What a crying shame that Kathy can’t get a life of her own and leave mine alone.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("To let the officer in, she stepped back…and collided with ")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("the cowboy. Strong fingers caught her upper shoulders. “Whoa now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("A few minutes ago, she’d been entertaining the idea of getting to know him better. Now that she was completely humiliated, she wanted him gone before she and her family further debased themselves in his presence.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“Nate, I appreciate your help in fixing the washer. Thanks so much. I’ll call you later about visiting the ranch.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("Nate didn’t seem the least bit moved by her obvious dismissal. “Someone’s crying back there.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("Her head swung toward the back of the house and then returned to the officer. “I need to see about the kids.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“This will only take a minute.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“I’ll go.” Before she could protest, Nate’s lanky legs carried him down the hall.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("Surprised and more than a little touched, Rainy lifted both hands toward the officer and said, “Come on in and have a look. This morning has been incredibly hectic but all the noise is harmless, as always. Katie had a stomach virus. She screams when she hurts. Or about any other time she wants to communicate.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“Yes, ma’am. I understand.” The officer glanced around the now tidy living room. “I see you have a couple of new ones over there.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“Temporaries. They arrived last night.” She cast a glance toward the bedrooms. The crying had stopped.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("Astonishingly, the twins remained asleep. As if he couldn’t resist, the sturdy young cop headed toward the playpen. “I got one about this size. They can be into everything.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“These two have been so exhausted, they’ve mostly slept and eaten.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("“That’s not natural,” he said with a chuckle. “Just wait till they get rested up.”")])])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hopefully, social services will find another placement for them by then. I’m not exactly set up for infants.” She turned toward the hallway. “The other children are back here. But please be very gentle with them. They’re terrified of you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sorry about that, but I have to do my job.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know. Come on. Let’s get this over with.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Officer Wagner was young, fresh-faced and genuinely kind, but that had never mattered to the kids. He wore a uniform and that was enough to set Joshua and Emma back for a week. Didn’t Kathy Underkircher understand that the real victims of her animosity were innocent children? Even if she knew, would she care?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bitterness gathered like acid on Rainy’s tongue. She’d prayed about the woman, asking the Lord to deal with Kathy’s hard heart. And now this. Again. On the worst day possible. In front of Nate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thanks a lot, Lord.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Whipping around, she led Officer Wagner through the house and pushed open the door to her bedroom. Her embarrassment at having two men see her unmade bed and pink pajamas was quickly forgotten. Nate Del Rio perched on the edge of her desk chair with Emma clinging to his knee like a blond wood tick. The boys were huddled next to his sides like baby chicks against a hen. In ordinary circumstances, the comparison of the hunky cowboy with a hen would have been amusing. Today, the sight was endearing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Everything okay in here?” she asked, her gaze searching each of the children’s faces.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Will nodded solemnly. Joshua, bless his heart, trembled like an earthquake but followed his brother’s example. Rainy’s heart ached for the little guy. Emma’s wide, troubled eyes were glued to the policeman.")])])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“As you can see, Officer,” Nate said, dropping a hand onto each of the boys’ shoulders, “the kids are fine.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Is this all of them?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Katie chose that moment to answer for herself. She screamed.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6d5996","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hometocrossroadsranch_ch02.vue
// module id = 90
// module chunks = 0